import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { MainContext } from "./context";
import Header from "./components/Header";
import Navbar from "./components/Navbar";
import NotFound from "./pages/NotFound";
import Login from "./pages/Login";
import Health from "./pages/Health";
import Medical from "./pages/Medical";
import MedicalAdd from "./pages/Medicaladd";
import Healthupdate from "./pages/Healthupdate";
import Medicalupdate from "./pages/Medicalupdate";
import HealthAdd from "./pages/Healthadd";
import ContactForms from "./pages/ContactForm";
import Form from "./pages/Form";
import Qna from "./pages/Qna";
import QnaPage from "./pages/QnaPage";
import Test from "./components/Test";
import Categories from "./components/Categories";
import Menu from "./components/Menu";
import MenuCategory from "./pages/MenuCategory";
import MenuCategorySinlge from "./pages/MenuCategorySingle";
import MenuCategoryAdd from "./pages/MenuCategoryAdd";
import MenuSubAdd from "./pages/MenuSubAdd";
import UserApi from "./components/UserApi";
import Logout from "./pages/Logout";
import HealthAddTest from "./pages/HealthAddTest";

function App() {
  const { theme } = UserApi();
  const bodyClassChange = () => {
    console.log(theme)
  };
  useEffect(() => {}, []);
  bodyClassChange();
  useEffect(() => {
    //effect
    return () => {
      //cleanup
    };
  }, [location.pathname]);
  return (
    <MainContext.Provider>
      <div className="App">
        <Header />

        <Navbar />
        <Routes></Routes>
        <div className="main">
          <Routes>
            <Route path="*" exact element={<NotFound />}></Route>
            <Route path="/" element={<Health />}></Route>
            <Route path="/health" element={<Health />}></Route>
            <Route path="/health/add" element={<HealthAdd />}></Route>
            <Route path="/health/update/:id" element={<Healthupdate />}></Route>
            <Route path="/medical" element={<Medical />}></Route>
            <Route path="/medical/add" element={<MedicalAdd />}></Route>
            <Route
              path="/medical/update/:id"
              element={<Medicalupdate />}
            ></Route>
            <Route path="/contact-form" element={<ContactForms />}></Route>
            <Route path="/contact-form/:formId" element={<Form />}></Route>
            <Route path="/qna" element={<Qna />}></Route>
            <Route path="/qna/:Id" element={<QnaPage />}></Route>
            <Route path="/texeditor" element={<Test />}></Route>
            <Route path="/categories" element={<Categories />}></Route>
            <Route path="/menu" element={<Menu />}></Route>
            <Route path="/menu/:Id" element={<MenuCategory />}></Route>
            <Route path="/menu/:Id/add" element={<MenuSubAdd />}></Route>
            <Route
              path="/menu/:Id/:singleId"
              element={<MenuCategorySinlge />}
            ></Route>
            <Route path="/menu/add" element={<MenuCategoryAdd />}></Route>
            <Route path="/login" element={<Login />}></Route>
            <Route path="/logintest" element={<UserApi />} />
            <Route path="/loginapi" element={<Login />}></Route>
            <Route path="/logout" element={<Logout />}></Route>
            <Route path="/addtest" element={<HealthAddTest />}></Route> 
          </Routes>
        </div>
      </div>
    </MainContext.Provider>
  );
}

export default App;
